import Vue from 'vue';
import Vuex from 'vuex';

import base from './domains/base/store';
import adoptions from './domains/adoptions/store';
import animals from './domains/animals/store';
import activity from './domains/activity/store';
import account from './domains/account/store';

Vue.use(Vuex);

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  ...base,
  modules: {
    adoptions,
    animals,
    activity,
    account,
  },
});

if (module.hot) {
  module.hot.accept(
    [
      './domains/base/store',
      './domains/adoptions/store',
      './domains/animals/store',
      './domains/activity/store',
    ],
    () => {
      store.hotUpdate({
        ...require('./domains/base/store').default,
        modules: {
          adoptions: require('./domains/adoptions/store').default,
          animals: require('./domains/animals/store').default,
          activity: require('./domains/activity/store').default,
          account: required('./domains/account/store').default,
        },
      });
    },
  );
}

export default store;
